import React, { lazy, Suspense } from 'react';

const { JSBundles, BvFrontend: { helpers: { bootApp } } } = window;

const LazyUserMessages = lazy(() => (
  bootApp({
    app: JSBundles.userMessages,
    dependencies: [],
  }).then(() => window.UserMessages)
));

export default () => (
  <Suspense fallback={<></>}>
    <LazyUserMessages />
  </Suspense>
);
